// extracted by mini-css-extract-plugin
export default {"divider":"Divider_divider__E3N1s","text":"Divider_text__m59ko"};